import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchFeatureLaunches, fetchFeatureLaunchMeta, createFeatureLaunch,
  updateFeatureLaunch, toggleFeatureLaunchStatus, deleteFeatureLaunch,
} from "../services/featureLaunchService";

/** Feature launches (2026-10-26) — the dashboard's "new feature" announcements. */

const KEY = "feature-launches";

export const useFeatureLaunches = () =>
  useQuery({ queryKey: [KEY], queryFn: fetchFeatureLaunches, staleTime: 60 * 1000 });

export const useFeatureLaunchMeta = () =>
  useQuery({ queryKey: [KEY, "meta"], queryFn: fetchFeatureLaunchMeta, staleTime: 5 * 60 * 1000 });

const useLaunchMutation = (mutationFn, successMessage) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => {
      if (successMessage) toast.success(successMessage);
      queryClient.invalidateQueries({ queryKey: [KEY], refetchType: "all" });
    },
    // The service layer has already turned 403 / 404 / 422 into a readable line.
    onError: (err) => toast.error(err?.message || "Something went wrong"),
  });
};

export const useCreateFeatureLaunch = () =>
  useLaunchMutation((payload) => createFeatureLaunch(payload), "Launch saved");

export const useUpdateFeatureLaunch = () =>
  useLaunchMutation(({ id, ...payload }) => updateFeatureLaunch(id, payload), "Launch saved");

export const useToggleFeatureLaunch = () =>
  useLaunchMutation((id) => toggleFeatureLaunchStatus(id), null);

export const useDeleteFeatureLaunch = () =>
  useLaunchMutation((id) => deleteFeatureLaunch(id), "Launch deleted");
